import { Clipboard } from '@angular/cdk/clipboard';
import { Component, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { timer } from 'rxjs';
import { ConstantsService } from 'lemunzo-shared';

@Component({
    selector: 'apcam-error-toast-generic',
    imports: [
        ToastModule,
        MatButtonModule,
        MatIconModule,
        TranslatePipe,
        MatTooltipModule,
        ButtonModule,
    ],
    templateUrl: './error-toast-generic.component.html',
    styleUrl: './error-toast-generic.component.scss',
})
export class ErrorToastGenericComponent {
    SUPPORT_CONTACT_EMAIL = ConstantsService.SUPPORT_CONTACT_EMAIL;

    CLIENT_ERROR_TOAST_KEY = ConstantsService.CLIENT_ERROR_TOAST_KEY;

    COPY_ICON = 'pi pi-copy';
    CHECK_ICON = 'pi pi-check';

    currentCopyButtonIcon = this.COPY_ICON;

    constructor(
        private readonly clipboard: Clipboard,
        private readonly destroyRef: DestroyRef
    ) {}

    /**
     * Copy a preconfigured support service email to the clipboard and display a tooltip.
     *
     * @param tooltip The MatTooltip instance to display the "Copied" tooltip.
     */
    protected copyEmailAddressToClipboard(tooltip: MatTooltip) {
        // TODO: CSD-441 -> Refactor to `CopyButtonTooltipComponent`
        this.clipboard.copy(this.SUPPORT_CONTACT_EMAIL);
        this.currentCopyButtonIcon = this.CHECK_ICON;
        tooltip.show();
        timer(ConstantsService.COPIED_TOOLTIP_HIDE_DELAY)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                this.currentCopyButtonIcon = this.COPY_ICON;
                tooltip.hide();
            });
    }
}
